module.exports = __webpack_public_path__ + "static/media/fenster_on.bf210f64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/png/food-store/fenster_on.png
// module id = 495
// module chunks = 0